import request from '@/utils/request'

/**
 * 搜索详情列表
 * @param {*} params
 */
export function getMilestoneNode(params) {
  return request({
    url: '/bsMilestoneNode',
    method: 'get',
    params: params
  })
}
/**
 * 添加
 * @param {*} params
 */
export function addMilestoneNode(params) {
  return request({
    url: '/bsMilestoneNode/save',
    method: 'post',
    data: params
  })
}
/**
 * 修改
 */
export function editMilestoneNode(params) {
  return request({
    url: '/bsMilestoneNode/update',
    method: 'put',
    data: params
  })
}
/**
 * 通过id删除
 */
export function deleteMilestoneNode(id) {
  return request({
    url: `/bsMilestoneNode/${id}`,
    method: 'delete',
  })
}
/**
 * 查看详情
 */
export function getMilestoneNodeInfo(id) {
  return request({
    url: `/bsMilestoneNode/${id}`,
    method: 'get'
  })
}
